import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  setFeature: `${NAMESPACE}_SET_FEATURE`,
};

export const actionCreators = {
  setFeature: payload => ({ type: actions.setFeature, payload })
};

export default {
  actions,
  actionCreators,
};
